module.exports = __webpack_public_path__ + "img/flv.9b680cc6.svg";